var map = {
	"./Elastos.svg": 96309,
	"./activeProjectBanner.webp": 60923,
	"./avaxIcon.svg": 16083,
	"./benefitsAudit.svg": 38095,
	"./benefitsContact.svg": 92638,
	"./benefitsContract.svg": 86584,
	"./benefitsCustomer.svg": 49510,
	"./benefitsExposure.svg": 13713,
	"./benefitsLocker.svg": 42866,
	"./bnbIcon.svg": 16671,
	"./bronzeBadge.svg": 1504,
	"./chart.svg": 55374,
	"./clearFieldsIcon.svg": 64529,
	"./coinStackIcon.svg": 2820,
	"./coins.svg": 27020,
	"./commingSoonTag.svg": 48561,
	"./customSliderArrow.svg": 42983,
	"./diamondBadge.svg": 33759,
	"./discordIcon.svg": 51165,
	"./ethIcon.svg": 26832,
	"./expiredTag.svg": 83103,
	"./eye.svg": 21253,
	"./firstKeyBackground.svg": 59685,
	"./firstKeyIcon.svg": 81718,
	"./formIcon.svg": 11635,
	"./fourthKeyBackground.svg": 55467,
	"./fourthKeyIcon.svg": 89660,
	"./globe.svg": 68433,
	"./goldBadge.svg": 26341,
	"./goldMedal.svg": 36029,
	"./gotoIndicator.svg": 22186,
	"./launchProjectBackground.webp": 43554,
	"./launchpadDetailsIcon.svg": 27087,
	"./launchpadIndicator.svg": 18729,
	"./lockIcon.svg": 96660,
	"./medalIcon.svg": 47624,
	"./mediumIcon.svg": 76896,
	"./messageWarningIcon.svg": 2018,
	"./moonactive.svg": 5567,
	"./notes.svg": 94185,
	"./plansFeature1.svg": 93357,
	"./plansFeature2.svg": 94030,
	"./plansFeature3.svg": 25023,
	"./plansFeature4.svg": 7552,
	"./plansFeature5.svg": 5585,
	"./platinumBadge.svg": 8483,
	"./projectHeader.webp": 83934,
	"./rocketIcon.svg": 16385,
	"./rocketIconActive.svg": 38727,
	"./secondKeyBackground.svg": 82939,
	"./secondKeyIcon.svg": 71276,
	"./silverBadge.svg": 50790,
	"./smallbp.svg": 70293,
	"./smallbpActive.svg": 57331,
	"./stakingIcon.svg": 47746,
	"./telegramIcon.svg": 60284,
	"./thirdKeyBackground.svg": 98098,
	"./thirdKeyIcon.svg": 32505,
	"./timerIcon.svg": 10378,
	"./twitterIcon.svg": 77628,
	"./uploadLogo.svg": 86964,
	"./users.svg": 83029,
	"./websiteIcon.svg": 28638,
	"./whiteArrow.svg": 36416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77404;